import * as d3 from 'd3';
import Api from "../Api";
import Thinker from "../components/Thinker";

const MedianBarChart = function (options) {

    const container = $(options.container);

    function render() {
        const formatTime = d3.timeFormat("%M:%S"),
            formatMinutes = function (d) {
                return formatTime(new Date(2018, 0, 1, 0, 0, 0, d));
            };

        const margin = {top: 10, right: 30, bottom: 30, left: 50},
            width = container.width() - margin.left - margin.right,
            height = 500 - margin.top - margin.bottom;

        const x = d3.scaleBand()
            .range([0, width]);

        const y = d3.scaleLinear()
            .range([height, 0]);

        const yAxis = d3.axisLeft()
            .scale(y)
            .tickFormat(formatMinutes);

        const svg = d3.select(options.svg)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        Api.send(container.data('url')).done(function (results) {
            Thinker.end($(options.container));
            let data = [];
            for (let prop in results) {
                if (results.hasOwnProperty(prop)) {
                    data.push({index: prop, med: d3.median(results[prop])});
                }
            }

            const benchmark = d3.median(Object.values(results).flat());

            x.domain(data.map(function (d) {
                return d.index;
            }));
            y.domain([0, d3.max(data, function (d) {
                return d.med;
            })]);

            const bars = svg.selectAll('.bar')
                .data(data)
                .enter();

            bars.append('rect')
                .attr('class', 'bar')
                .attr('x', function (d) {
                    return x(d.index);
                })
                .attr('width', x.bandwidth())
                .attr('y', height)
                .attr('height', 0)
                // animate bars coming out
                .transition()
                .attr('y', function (d) {
                    return y(d.med);
                })
                .attr('height', function (d) {
                    return height - y(d.med);
                })
                .delay(function (d, i) {
                    return i * 20;
                })
                .duration(2000);

            bars.append('text')
                .attr("dy", "1.3em")
                .attr("x", function (d) {
                    return x(d.index) + x.bandwidth() / 2;
                })
                .attr("y", function (d) {
                    return y(d.med);
                })
                .attr("text-anchor", "middle")
                .attr("font-family", "sans-serif")
                .attr("font-size", "11px")
                .attr("fill", "white")
                .text(function (d) {
                    return formatMinutes(d.med);
                });

            svg.append('line')
                // .data(data)
                .attr('class', 'x')
                //.attr('id', 'dashedLine')
                .style('stroke', 'steelblue')
                .style('stroke-dasharray', '3,3')
                .attr('x1', function () {
                    return 0;
                })
                .attr('y1', function () {
                    return y(benchmark);
                })
                .attr('x2', function () {
                    return x(data.length) + x.bandwidth();
                })
                .attr('y2', function () {
                    return y(benchmark);
                });

            svg.append('g')
                .attr('transform', `translate(0, ${height})`)
                .call(d3.axisBottom(x));

            svg.append('g')
                .call(yAxis);
        });
    }

    $(options.container).find('form input').on('change', function () {
        $(options.svg).empty();
        render();
    });

    setTimeout(function () {
        Thinker.begin($(options.container));
        render();
    }, 100);

    function update() {
        $(options.svg).empty();
        Thinker.begin($(options.container));
        setTimeout(function () {
            render();
        }, 500);
    }

    $('body').on('click', '.hamburger a', function () {
        $(options.container).trigger('update');
    });

    $(options.container).on('update', function () {
        update();
    });
};

export default MedianBarChart;
